<template>
    <div class="page">
        <div class="gridheader">
            <div class="row">
                <div class="col-md-12 title">
                    <h1 class="mrgn">{{$t('PROFILE')}}</h1>
                    <ul class="list-unstyled">
                        <li v-if="globals.auth != 9 && globals.auth != 10" v-bind:class="(routename == 'Tasks') ? 'active' : ''">
                            <router-link v-bind:to="'/profile/tasks'">{{ $t('TASKS')}}</router-link>
                        </li>
                        <li v-bind:class="(routename == 'Chat') ? 'active' : ''">
                            <router-link v-bind:to="'/profile/chat'">{{ $t('CHAT')}}</router-link>
                        </li>
                        <li v-bind:class="(routename == 'Notifications') ? 'active' : ''">
                            <router-link v-bind:to="'/profile/notifications'">{{ $t('NOTIFICATIONS')}}</router-link>
                        </li>
                        <li class="d-none d-md-inline-block" v-bind:class="(routename == 'User') ? 'active' : ''">
                            <router-link v-bind:to="'/profile/user'">{{ $t('PERSONALDATA')}}</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>

import
{
    mapGetters
}
from 'vuex'

export default
{
    name: 'Profile',
    data: function()
    {
        return {

        };
    },
    created: function()
    {
        var me = this;
    },
    methods:
    {

    },
    watch:
    {

    },
    computed:
    {
        ...mapGetters([
            'globals'
        ]),
        routename()
        {
            return this.$route.name;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Profile.vue